import IdentifyA from './IdentifyA';
import IdentifyB from './IdentifyB';
import IdentifyC from './IdentifyC';
import IdentifyD from './IdentifyD';
import IdentifyE from './IdentifyE';
import IdentifyF from './IdentifyF';
import IdentifyG from './IdentifyG';

const Identify = {
  IdentifyA,
  IdentifyB,
  IdentifyC,
  IdentifyD,
  IdentifyE,
  IdentifyF,
  IdentifyG
};

export default Identify;



// WEBPACK FOOTER //
// ./src/containers/Identify/index.jsx